import React from "react";

import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { Button, Theme } from "@mui/material";
import { makeStyles } from "tss-react/mui";

type Props = React.ComponentProps<typeof Button>;
const useStyles = makeStyles()((theme: Theme) => ({
  goalButton: {
    "& .MuiButton-startIcon": {
      margin: "0px",
    },
    border: "2px solid #1FD4AF",
    "&:hover": {
      border: "2px solid #1FD4AF",
    },
    width: "28px",
    height: "28px",
    minWidth: "28px",
    borderRadius: "100%",
    marginLeft: "12px",
  },
}));

const EditIconButton: React.FC<Props> = (props) => {
  const { classes } = useStyles();
  return (
    <Button
      {...props}
      size="small"
      variant="outlined"
      startIcon={<EditRoundedIcon fontSize="small" />}
      className={classes.goalButton}
    ></Button>
  );
};

export default EditIconButton;
